import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { GlobalStyle } from '@styles/globalstyles.js';
import { Provider } from 'react-redux';
import { store } from '@store/index.js';
import { MsalAuthProvider } from '@hooks/auth/msal-provider.jsx';
import { AppAuthProvider } from '@contexts/AuthContext.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <GlobalStyle />
    <MsalAuthProvider>
      <AppAuthProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </AppAuthProvider>
    </MsalAuthProvider>
  </StrictMode>
);
